import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getContactServiceList, getDeviceAccess, getWishList, partnerApi, vendorDashboard , partnerCategory } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import {
  Collapse, CardBody, Card, CardHeader, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader
} from 'reactstrap';

import Tabs from "../Tabs";

import TabsPane from "../Tabs/TabsPane";

import DataTable from 'react-data-table-component';

import Branch from './branch/branch';
import Curated from './branch/curatedcamps';


const childTabs = [
    {
        name: "Branches",
        id: "branch",
        defaultChecked: true,
    }
    /*
    {
        name: "BeWise Curated Camps",
        id: "curated",
    }
    */
];

class partnerBranches extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
    }
 
  }

  componentDidMount() {
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  render() {
 

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Branches</h4>
                    
                        <Tabs tabsetName="dashboard" childTabs={childTabs}>
                                    <TabsPane id="branch">
                                        <Branch />
                                    </TabsPane>
                                    <TabsPane id="curated">
                                        <Curated />
                                    </TabsPane>
                        </Tabs>
                   
                </div>
              </div>
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerBranches;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/branches.jsx